import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color"];
import * as React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';
function Roles(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? colors.neutral700 : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.03 5.922C12.886 2.647 10.386.295 7.333.295 4.188.295 1.63 2.79 1.63 6.222V8H.407l-.093.012A.438.438 0 0 0 0 8.444v11.112l.008.181c.084.896.779 1.596 1.622 1.596H12v-7c0-.74.482-1.405 1.185-1.605v-.061c0-1.576.56-3.025 1.482-4.103v-.12l-.011-.102A.416.416 0 0 0 14.259 8h-1.222V6.222l-.007-.3Zm-8.956.3c0-1.96 1.462-3.555 3.26-3.555 1.796 0 3.259 1.595 3.259 3.555V8H4.074V6.222Zm18.74 6.445c0-2.574-1.86-4.429-4.147-4.429-2.288 0-4.149 1.855-4.149 4.429V14h-.888c-.164 0-.297.15-.297.333v8.334c0 .735.532 1.333 1.185 1.333h8.297c.653 0 1.185-.598 1.185-1.333v-8.334c0-.184-.133-.333-.296-.333h-.89v-1.333Zm-6.518 0V14h4.741v-1.333c0-1.47-1.063-2.667-2.37-2.667-1.307 0-2.37 1.196-2.37 2.667Z",
    fill: color
  }));
}
export default Roles;